import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _650525f6 = () => interopDefault(import('../pages/countries.vue' /* webpackChunkName: "pages/countries" */))
const _2bd37000 = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _f56c1a8c = () => interopDefault(import('../pages/no-subscription.vue' /* webpackChunkName: "pages/no-subscription" */))
const _6fcbb0ca = () => interopDefault(import('../pages/redirect.vue' /* webpackChunkName: "pages/redirect" */))
const _7dc23ed8 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _5876feba = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _de44c5ba = () => interopDefault(import('../pages/_countryCode.vue' /* webpackChunkName: "pages/_countryCode" */))
const _38ba7d66 = () => interopDefault(import('../pages/_countryCode/index.vue' /* webpackChunkName: "pages/_countryCode/index" */))
const _92e56fa0 = () => interopDefault(import('../pages/_countryCode/_disciplineCode.vue' /* webpackChunkName: "pages/_countryCode/_disciplineCode" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/countries",
    component: _650525f6,
    name: "countries"
  }, {
    path: "/help",
    component: _2bd37000,
    name: "help"
  }, {
    path: "/no-subscription",
    component: _f56c1a8c,
    name: "no-subscription"
  }, {
    path: "/redirect",
    component: _6fcbb0ca,
    name: "redirect"
  }, {
    path: "/terms",
    component: _7dc23ed8,
    name: "terms"
  }, {
    path: "/",
    component: _5876feba,
    name: "index"
  }, {
    path: "/:countryCode",
    component: _de44c5ba,
    children: [{
      path: "",
      component: _38ba7d66,
      name: "countryCode"
    }, {
      path: ":disciplineCode",
      component: _92e56fa0,
      name: "countryCode-disciplineCode"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
